export default "__VITE_ASSET__V3Oy2CX9Ii5YsNdQd38_xw__"